<template>
  <div class="checkout notranslate">
    <!-- 확인 전 -->
    <div v-if="!result && !status">
      <div class="message">
        <h1>{{locale.checkout_loading}}</h1>
        <p>{{locale.please_wait}}</p>
      </div>
    </div>
    <!-- //확인 전 -->
    <!-- ota 없음 -->
    <div v-else-if="!reviewUrl" class="question">
      <div class="message">
        <h1>{{locale.unknown_roominfo}}</h1>
        <p class="checkoutTime">{{locale.alert_checkout_times}} {{ checkoutTime.time }}</p>
        <h2>{{locale.checkout_fail_invalidfoliostatus}}</h2>
        <p>{{locale.checkout_fail_ask_frontdesc}}</p>
      </div>
    </div>
    <!-- //ota 없음 -->
    <!-- 체크아웃 진행 -->
    <div v-else>
      <!-- 체크아웃 가능 -->
      <div v-if="status === 1" class="possible">
        <div class="message">
          <h1>{{locale.checkout_progress_1}}</h1>
          <p class="checkoutTime">{{locale.alert_checkout_times}} {{ checkoutTime.time }}</p>
          <p>{{locale.checkout_progress_2}}</p>
          <div class="btns">
            <button type="button" class="btn btnWhite" @click="cancelCheckout">{{locale.no}}</button>
            <button type="button" class="btn" @click="reqCheckout">{{locale.yes}}</button>
          </div>
        </div>
      </div>
      <!-- //체크아웃 가능 -->
      <!-- 체크아웃 진행 -->
      <div v-else-if="status === 2">
        <!-- 체크아웃 성공 -->
        <div v-if="result === 'success'" class="success">
          <div class="message">
            <h1>{{locale.checkout_success_1}}</h1>
            <h2>{{locale.checkout_success_2}}</h2>
            <p>{{locale.please_review_1}}</p>
            <p>{{locale.please_review_2}}</p>
          </div>
          <div class="btns">
            <button type="button" class="btn btnWhite">{{locale.no}}</button>
            <a :href="reviewUrl" class="btn">{{locale.yes}}</a>
          </div>
        </div>
        <!-- //체크아웃 성공 -->
        <!-- 체크아웃 불가 -->
        <div v-else class="fail">
          <div class="message">
            <h1>{{locale.checkout_fail}}</h1>
            <!-- 룸차지 있음 -->
            <h2 v-if="result === 'roomcharge'">{{locale.checkout_fail_roomcharge}}</h2>
            <h2 v-if="result === 'notToday'">{{locale.checkout_fail_nottoday}}</h2>
            <h2 v-if="result === 'invalidFolioNo'">{{locale.checkout_fail_invalidfoliono}}</h2>
            <h2 v-if="result === 'invalidFolioStatus'">{{locale.checkout_fail_invalidfoliostatus}}</h2>
            <h2 v-if="result === 'unknownErr'">{{locale.message_unknown_error}}</h2>
            <p>{{locale.checkout_fail_ask_frontdesc}}</p>
          </div>
        </div>
        <!-- //체크아웃 불가 -->
      </div>
      <!-- //체크아웃 진행 -->
      <!-- 체크아웃 불가 -->
      <div v-else-if="status === 3" class="fail">
        <div class="message">
          <h1>{{locale.checkout_fail}}</h1>
          <p class="checkoutTime">{{locale.alert_checkout_times}} {{ expireTime }}</p>
          <!-- 룸차지 있음 -->
          <h2 v-if="result === 'roomcharge'">{{locale.checkout_fail_roomcharge}}</h2>
          <h2 v-if="result === 'notToday'">{{locale.checkout_fail_nottoday}}</h2>
          <h2 v-if="result === 'invalidFolioNo'">{{locale.checkout_fail_invalidfoliono}}</h2>
          <h2 v-if="result === 'invalidFolioStatus'">{{locale.checkout_fail_invalidfoliostatus}}</h2>
          <h2 v-if="result === 'unknownErr'">{{locale.message_unknown_error}}</h2>
          <p>{{locale.checkout_fail_ask_frontdesc}}</p>
        </div>
      </div>
      <!-- //체크아웃 불가 -->
    </div>
    <!-- //체크아웃 진행 -->
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import moment from 'moment-timezone'

export default {
  name: 'Checkout',
  props: [
    'ln',
    'locale',
    'isPublic'
  ],
  computed: {
    authInfo () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    custom () {
      const setting = this.$store.getters['common/getSetting']
      const inroom = setting && setting.inroom
      return inroom
        ? {
          checkoutTrue: inroom.checkoutTrue && inroom.checkoutTrueUrl && regExp.replaceAllEmpty(inroom.checkoutTrueUrl.pageId).length > 0 && inroom.checkoutTrueUrl.pageId,
          checkoutFalse: inroom.checkoutFalse && inroom.checkoutFalseUrl && regExp.replaceAllEmpty(inroom.checkoutFalseUrl.pageId).length > 0 && inroom.checkoutFalseUrl.pageId
        }
        : null
    },
    checkoutTime () {
      const expireTime = this.expireTime
      const hh = expireTime.split(':')[0]
      const mm = expireTime.split(':')[1]
      const iso = moment().set({ hour: hh, minute: mm })
      return expireTime && {
        hh: iso.hours(),
        mm: iso.minutes(),
        time: iso.format('HH:mm A')
      }
    }
  },
  async mounted () {
    this.$store.commit('loading', true)
    await this.$store.dispatch('authentication/getOtaKey')
    this.getCheckoutStatus()
    this.getReviewUrl()
    this.$store.commit('loading', false)
  },
  data () {
    return {
      reviewUrl: null,
      status: null, // 1: 가능, 2: 진행중, 3: 불가
      result: null, // 'success', 'roomcharge'
      expireTime: null
    }
  },
  methods: {
    getReviewUrl () {
      const ota = this.authInfo && this.authInfo.otavalid !== 'false' && this.authInfo.k
      const location = 'https://review.istay.io/index.html'
      const params = ota ? `k=${ota}` : null
      this.reviewUrl = params && `${location}?${params}`
    },
    async getCheckoutStatus () {
      const authentication = this.$store.state.authentication
      const siteid = authentication && authentication.site
      const spaceid = authentication && authentication.space
      const key = authentication && authentication.k
      const custom = this.custom
      this.$store.commit('loading', true)
      await this.$store.dispatch('guest/getCheckoutStatus', {
        siteid: siteid,
        spaceid: spaceid,
        key: key
      }).then((res) => {
        const resCode = res && res.message && res.message.code
        this.expireTime = res && res.message && res.message.expireTime
        if (resCode === 2001) {
          this.status = 1
        } else {
          this.status = 3
          if (res && res.status && res.status === 403) {
            alert(this.locale.alert_not_support)
            this.$router.push({
              name: 'main'
            })
          } else {
            if (resCode === 3001) {
              this.result = 'notToday'
              // alert('체크아웃 날짜가 아닙니다.')
            } else if (resCode === 3002) {
              this.result = 'invalidFolioNo'
              // alert('유효하지 않은 폴리오 입니다.')
            } else if (resCode === 3003) {
              this.result = 'invalidFolioStatus'
              // alert('체크아웃을 할 수 없는 폴리오 입니다.')
            } else if (resCode === 3005) {
              this.result = 'roomcharge'
            } else {
              this.result = 'unknownErr'
            }
            if (custom && custom.checkoutFalse) {
              this.$router.push({
                name: 'page',
                params: {
                  id: custom.checkoutFalse
                }
              })
            }
          }
        }
        this.$store.commit('loading', false)
      })
      this.$store.commit('loading', false)
    },
    confirmCheckout () {
      return confirm(`${this.locale.confirm_checkout_1}\n${this.locale.confirm_checkout_2}`)
    },
    cancelCheckout () {
      alert(this.locale.alert_cancel_checkout)
    },
    reqCheckout () {
      const authentication = this.$store.state.authentication
      const siteid = authentication && authentication.site
      const spaceid = authentication && authentication.space
      const key = authentication && authentication.k
      const custom = this.custom
      if (this.confirmCheckout()) {
        if (siteid && spaceid && key) {
          this.$store.commit('loading', true)
          this.$store.dispatch('guest/setCheckout', {
            siteid: siteid,
            spaceid: spaceid,
            key: key
          }).then((res) => {
            const resCode = res && res.message && res.message.code
            this.status = 2
            if (resCode === 2000) {
              this.result = 'success'
              if (custom && custom.checkoutTrue) {
                this.$router.push({
                  name: 'page',
                  params: {
                    id: custom.checkoutTrue
                  }
                })
              }
            } else {
              if (res && res.status && res.status === 403) {
                alert(this.locale.alert_not_support)
                this.$router.push({
                  name: 'main'
                })
              } else {
                if (resCode === 3001) {
                  this.result = 'notToday'
                  // alert('체크아웃 날짜가 아닙니다.')
                } else if (resCode === 3002) {
                  this.result = 'invalidFolioNo'
                  // alert('유효하지 않은 폴리오 입니다.')
                } else if (resCode === 3003) {
                  this.result = 'invalidFolioStatus'
                  // alert('체크아웃을 할 수 없는 폴리오 입니다.')
                } else if (resCode === 3005) {
                  this.result = 'roomcharge'
                } else {
                  this.result = 'unknownErr'
                }
                if (custom && custom.checkoutFalse) {
                  this.$router.push({
                    name: 'page',
                    params: {
                      id: custom.checkoutFalse
                    }
                  })
                }
              }
            }
            // 결과에 따라 커스텀 페이지 이동
            this.$store.commit('loading', false)
          })
          this.$store.commit('loading', false)
        } else {
          this.status = 2
          alert(this.locale.access_retry)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout {
  max-width: 640px;
  margin: auto;
  padding: 60px 30px;
  .message {
    text-align: center;
    p {
      margin-bottom: 15px;
    }
  }
  h1 {
    margin-bottom: 10px;
    font-size: 24px;
    line-height: 1.3;
    &:before {
      content: "";
      display: block;
      height: 64px;
      margin-bottom: 30px;
      background-position: 50% 0;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('~@/assets/img/ellipsis.png');
      opacity: 0.15;
    }
  }
  h2 {
    margin-bottom: 30px;
    // font-size: 14px;
    color: $color-grey;
  }
  .checkoutTime {
    display: inline-block;
    margin-bottom: 10px;
    padding: 4px 18px 4px 40px;
    text-align: center;
    color: $color-white;
    border-radius: 50px;
    background: #c1c9d0 url('~@/assets/img/ico_clock_wh.png') 10px 50% / 24px no-repeat;
  }
  .possible {
    h1:before {
      background-image: url('~@/assets/img/ico_logout.png');
      opacity: 0.15;
    }
  }
  .success {
    h1:before {
      background-image: url('~@/assets/img/complete.png');
      opacity: 1;
    }
  }
  .fail {
    h1:before {
      background-image: url('~@/assets/img/warn.png');
      opacity: 1;
    }
  }
  .question {
    h1:before {
      background-image: url('~@/assets/img/ico_question.png');
      opacity: 1;
    }
  }
  .btns {
    display: flex;
    margin-top: 30px;
    .btn {
      flex: 1;
      border-radius: 8px;
      & + .btn {
        margin-left: 8px;
      }
    }
  }
}
</style>
